<template>
  <div class="pt-16 2xl:pt-24 pb-28">

    <DisplayProfileHeader :professional-data="professionalData.professional" />

    <!-- section presentation -->
    <section class="lg:container lg:mx-auto px-5">
      <DisplayProfilePresentation :presentations="professionalData.presentations" />
    </section>    

    <section class="grid grid-cols-1 lg:grid-cols-4 gap-3 px-5 lg:container lg:mx-auto">
      <div class="lg:col-span-3 flex flex-wrap md:flex-nowrap md:gap-x-3">
        <!--  language, skills, graduation section -->
        <section class="w-full md:w-1/3">
          <DisplayProfileLanguages :languages="professionalData.languages" />

          <DisplayProfileSkills :skills="professionalData.skills" />

          <DisplayProfileAdditionalInfo :add-information="professionalData.additional_information" />
         
          <DisplayProfileGraduation :educations="professionalData.educations" />
        </section>

        <!-- seção Experiência -->
        <section class="w-full md:w-2/3">
          <DisplayProfileExperiences :experiences="professionalData.experiences" />
        </section>
      </div>

      <!-- Barra lateral Perfis semelhantes -->
      <div class="col-span-1 xl:pl-2">
        <div
          class="p-5 mt-5 md:mt-9 bg-white rounded-lg shadow-md border border-color-iron"
        >
          <h1 class="mb-4 font-semibold md:text-center lg:text-left text-oxford-blue">
            Perfis semelhantes
          </h1>
          <ul class="md:flex md:flex-wrap md:justify-center gap-5 md:mt-7 lg:mt-0">
            <li
              v-for="n in 6"
              :key="n"
              class="flex gap-x-1 md:flex-col lg:flex-row md:items-center lg:items-start md:gap-3 md:p-4 lg:p-0 mb-3 md:bg-white lg:md:bg-none md:shadow-lg lg:shadow-none"
            >
              <img
                src="@/assets/images/avatar.png"
                class="w-11 h-11 md:w-20 md:h-20 lg:w-11 lg:h-11 xl:w-14 xl:h-14 rounded-full"
              />
              <span class="md:text-center lg:text-left">
                <h2 class="text-sm font-medium capitalize text-oxford-blue">
                  Mungongo Teixeira Martuns
                </h2>
                <h3 class="text-sm font-normal">Engenheiro de Software</h3>
                <h4 class="text-sm font-normal">Lisbo, Portugal</h4>
              </span>
            </li>
          </ul>
        </div>

        <!-- Área de publicidade -->
        <div
          class="hidden p-5 mt-6 py-10 bg-white rounded-lg shadow-md border border-color-iron"
        >
          <h1 class="font-bold text-center text-oxford-blue">Espaço para publicidade</h1>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import requestHandler from "@/composables/requestHandler";
import DisplayProfileHeader from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfileHeader"; 
import DisplayProfilePresentation from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfilePresentation"; 
import DisplayProfileLanguages from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfileLanguages"; 
import DisplayProfileGraduation from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfileGraduation"; 
import DisplayProfileSkills from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfileSkills"; 
import DisplayProfileAdditionalInfo from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfileAdditionalInfo"; 
import DisplayProfileExperiences from "@/components/Dashboard/Applicant/DisplayPublicProfile/DisplayProfileExperiences"; 

  

let professionalData = ref({});
let route = useRoute();

// ############ Criação de Métodos/Funções ############

async function getProfissional() {

  const response = await requestHandler.executeRequest(`/api/professional/find/${route.params.name}`,{},'get');
  
  if(response.success){
    professionalData.value = response.data
  }
  
}

// ############ Ciclos de Vida/Hooks ############

onBeforeMount(() => {
  getProfissional();
});
</script>
